import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { Galleria } from 'primereact/galleria';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from 'primereact/multiselect';
import { ProgressBar } from 'primereact/progressbar';
import { Rating } from "primereact/rating";
import { Skeleton } from 'primereact/skeleton';
import { Slider } from "primereact/slider";
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { ToggleButton } from 'primereact/togglebutton';
import { Tooltip } from 'primereact/tooltip';
import React, { useCallback, useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import { ApartmentsTypesOption } from '../Helper/data_static';
import { _endPoints, baseUrl, googleMapsApiKey } from "../Helper/links";
import pattern from "../Helper/pattern";
import API from "../Helper/server/API";
import '../public/themes/saga-blue/theme.css';
import { SelectButton } from 'primereact/selectbutton';
import { FamilyType, StayType } from "../constants/data";

// ✅ أضف هذه التعريفات
const libraries = ["places"];
const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "1rem",
};
const center = {
  lat: 32.720051928614744, // طرابلس
  lng: 14.058778860698071,
};


function ApartmentUpdateComponet(data) {

  const galleria = useRef(null);
  const stepperRef = useRef(null);
  const toast = useRef(null);
  const [state, set_state] = useState(false);
  const [stay_type, set_stay_type] = useState(null);
  const [family_type, setfamily_type] = useState(null);
  const handelfamily_type = (e) => {
    if (pattern.number_int.test(e.value) === true && e.value <= 3 && e.value >= 1) {
      setfamily_type(e.value)
      document.getElementById("lfamily_type").style.color = null;
    } else {

    }
  }
  const [number, setnumber] = useState("");
  const [name, setname] = useState("");
  const [type, settype] = useState("");
  const [address, setaddress] = useState("");
  const [position_n, setposition_n] = useState("");
  const [position_e, setposition_e] = useState("");
  const [sea_distance, setsea_distance] = useState("");
  const [rating_star, set_rating_star] = useState(0);
  const [details, setdetails] = useState("");
  const [price, setprice] = useState(0);
  const [discount, setdiscount] = useState(0);
  //_______________________________________________________
  const [number_people, setnumber_people] = useState(0);
  const [number_bedrooms, setnumber_bedrooms] = useState(0);
  const [number_living_room, setnumber_living_room] = useState(0);
  const [number_kitchen, setnumber_kitchen] = useState(0);
  const [number_bathrooms, setnumber_bathrooms] = useState(0);
  //_______________________________________________________
  const [kitchen_utensils, setkitchen_utensils] = useState(0);
  const [refrigerator, setrefrigerator] = useState(0);
  const [gas, setgas] = useState(0);
  const [television, settelevision] = useState(0);
  const [generator, setgenerator] = useState(0);
  const [grill, setgrill] = useState(0);
  const [swimming_pool, setswimming_pool] = useState(0);
  const [Internet, setInternet] = useState(0);
  //_______________________________________________________
  const handelnumber = (e) => {
    if (pattern.number_name_ar_en.test(e.target.value) === true && e.target.value.length <= 10 || e.target.value === "") {
      setnumber(e.target.value)
      document.getElementById("lnumber").style.color = null;
    }
    else {
      document.getElementById("lnumber").style.color = 'red';
    }
  }
  const handelname = (e) => {
    if ((pattern.name_en_ar.test(e.value) || e.target.value === '' || e.target.value === null) && e.target.value.length <= 100) {
      setname(e.target.value)
      document.getElementById("lname").style.color = 'black';
    }
    else {
      document.getElementById("lname").style.color = 'red';
    }
  }
  const handeladdress = (e) => {
    if (pattern.name_ar.test(e.target.value) === true && e.target.value.length <= 30) {
      setaddress(e.target.value)
      document.getElementById("laddress").style.color = 'black';
    }
    else {
      document.getElementById("laddress").style.color = 'red';
    }
  }
  const handeltype = (e) => {
    if (ApartmentsTypesOption.includes(e.target.value))
      settype(e.target.value)
    else
      document.getElementById("ltype").style.color = null;
  }
  const handelsea_distance = (e) => {
    if (pattern.number_int.test(e.value) === true && e.value <= 1000 && e.value >= 0) {
      setsea_distance(e.value)
      document.getElementById("lsea_distance").style.color = null;
    }
    else {
      document.getElementById("lsea_distance").style.color = 'red';
    }
  }
  const handelsea_distance_target = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value <= 1000 && e.target.value >= 0) {
      setsea_distance(e.target.value)
      document.getElementById("lsea_distance").style.color = null;
    }
    else {
      document.getElementById("lsea_distance").style.color = 'red';
    }
  }
  const handelrating_star = (e) => {
    if (pattern.number_float.test(e.value) === true && e.value >= 1.0 && e.value <= 5.0) {
      set_rating_star(e.target.value)
      document.getElementById("lrating_star").style.color = null;
    }
    else {
      document.getElementById("lrating_star").style.color = 'red';
    }
  }

  const handeldetails = (e) => {
    if ((pattern.notes.test(e.target.value) === true || e.target.value === '' || e.target.value === null)) {
      setdetails(e.target.value.replace(/[\r]/g, ' '))
      document.getElementById("ldetails").style.color = null;
    }
    else {
      document.getElementById("ldetails").style.color = 'red';
    }
  }
  const handelprice = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value <= 1000000 && e.target.value >= 0) {
      setprice(e.target.value)
      document.getElementById("lprice").style.color = null;
    }
    else {
      document.getElementById("lprice").style.color = 'red';
    }
  }
  const handeldiscount = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value <= price && e.target.value >= 0) {
      setdiscount(e.target.value)
      document.getElementById("ldiscount").style.color = null;
    }
    else {
      document.getElementById("ldiscount").style.color = 'red';
    }
  }
  //_______________________________________________________________________________________
  const handelnumber_people = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value >= 0 && e.target.value <= 50) {
      setnumber_people(e.target.value)
      document.getElementById("lnumber_people").style.color = null;
    }
    else {
      document.getElementById("lnumber_people").style.color = 'red';
    }
  }
  const [number_people_max, setnumber_people_max] = useState(0);
  const handelnumber_Maxpeople = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value >= 0 && e.target.value <= 50) {
      setnumber_people_max(e.target.value)
      document.getElementById("lnumber_people").style.color = null;
    }
    else {
      document.getElementById("lnumber_people").style.color = 'red';
    }
  }
  const handelnumber_bedrooms = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value >= 1 && e.target.value <= 10) {
      setnumber_bedrooms(e.target.value)
      document.getElementById("lnumber_bedrooms").style.color = 'black';
    }
    else {
      document.getElementById("lnumber_bedrooms").style.color = 'red';
    }
  }
  const handelnumber_living_room = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value >= 1 && e.target.value <= 10) {
      setnumber_living_room(e.target.value)
      document.getElementById("lnumber_living_room").style.color = 'black';
    }
    else {
      document.getElementById("lnumber_living_room").style.color = 'red';
    }
  }
  const handelnumber_kitchen = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value >= 1 && e.target.value <= 10) {
      setnumber_kitchen(e.target.value)
      document.getElementById("lnumber_kitchen").style.color = 'black';
    }
    else {
      document.getElementById("lnumber_kitchen").style.color = 'red';
    }
  }
  const handelnumber_bathrooms = (e) => {
    if (pattern.number_int.test(e.target.value) === true && e.target.value >= 1 && e.target.value <= 10) {
      setnumber_bathrooms(e.target.value)
      document.getElementById("lnumber_bathrooms").style.color = 'black';
    }
    else {
      document.getElementById("lnumber_bathrooms").style.color = 'red';
    }
  }
  const [selectedAccessories, setSelectedAccessories] = useState(null);

  const [accessories, setAccessories] = useState([]);
  const GetAccessories = async () => {
    const res = await API.get(_endPoints.apartments.get_accessories);
    if (res?.success) {
      setAccessories(res.data);
    }
  }
  const accessoriesTemplateSelected = (option) => {
    return (
      <>
        <div className="p-multiselect-representative-option p-2">
          <span>{option.name_ar}</span>
        </div>
      </>
    );
  }
  const [LodingGetAartment, setLodingGetAartment] = useState(true);
  const GetAartment = async (ID_apartment) => {
    setLodingGetAartment(true)
    const res = await API.get(`${_endPoints.apartments.get_apartment}?ID_apartment=${ID_apartment}`);
    if (res?.success) {
      if (res?.data) {
        set_state(res.data?.state == 1 ? true : false);
        settype(ApartmentsTypesOption.find(item => item?.en === res.data?.type));
        set_stay_type(StayType.find(item => item?.value === res.data?.stay_type));
        setnumber(res.data?.number);
        setname(res.data?.name);
        setnumber_people(res.data?.number_people);
        setnumber_people_max(res.data?.number_people_max);
        setfamily_type(FamilyType.find(item => item?.value * 1 === res.data?.family_type * 1));
        set_rating_star(res.data?.rating_star);
        setprice(res.data?.price);
        setdiscount(res.data?.discount);
        setnumber_bedrooms(res.data?.number_bedrooms);
        setnumber_living_room(res.data?.number_living_room);
        setnumber_kitchen(res.data?.number_kitchen);
        setnumber_bathrooms(res.data?.number_bathrooms);
        setdetails(res.data?.details);
        setsea_distance(res.data?.sea_distance);
        setArryaMaxPepole({
          lat: parseFloat(res.data?.latitude),
          lng: parseFloat(res.data?.longitude),
        });
        setSelectedAccessories(res.data?.accessories);
        set_files(res.data?.files);
        setLodingGetAartment(false)
      }
    }
    else {
      toast.current.show({
        style: {
          fontFamily: "Cairo",
          fontSize: "1.2rem"
        },
        life: 5000,
        severity: 'error', summary: 'خطــاء', detail: res?.msg
      });
    }
  }
  useEffect(() => {
    GetAartment(data.ID_apartment);
    GetAccessories();
  }, [])

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries,
  });
  const onMapClick = useCallback((e) => {
    setArryaMaxPepole({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  }, []);

  const [ArryaMaxPepole, setArryaMaxPepole] = useState(center);
  const [items, setItems] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]);
  const search = (event) => {
    if (event.query <= 50 && event.query >= 0) {
      setItems([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50].filter(item => event.query <= item));
    }

  }
  const maxPepoleTemplateSelected = (value) => {
    return <p>{value}  <i className="pi pi-users"></i> </p>
  }
  const maxTotalFilesSize = 104857600; // 100 MB
  const maxFileSize = 10485760; // 10 MB
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef(null);
  const [files, set_files] = useState([]);
  const [can_sort, set_can_sort] = useState(true);
  const onTemplateSelect = (e) => {
    set_can_sort(false)
    set_files(e.files);
    var _totalSize = 0;
    let _files = e.files;
    Object.keys(_files).forEach((key) => {
      _totalSize += (_files[key].size) || 0;
    });
    setTotalSize(_totalSize);
  };
  const [files_delete, set_files_delete] = useState([]);


  const onTemplateUpload = (e) => {
    let _totalSize = 0;
    e.files.forEach((_file) => {
      _totalSize += (_file.size) || 0;
    });
    setTotalSize(_totalSize);
  };

  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    set_files([]);
    setTotalSize(0);
  };

  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = ((totalSize / maxTotalFilesSize) * 100)
    const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="flex align-items-center  ml-auto">
          {chooseButton}
          {cancelButton}
        </div>
        <span dir="ltr">{formatedValue} / {`${(maxTotalFilesSize / 1048576).toFixed(0)} MB`} </span>
        <ProgressBar
          value={value}
          showValue={false}
          style={{ width: "20rem", height: "12px" }}
        ></ProgressBar>
      </div>
    );
  };
  const itemTemplate = (file, props) => {
    return <></>
  };
  const [activeIndex, setActiveIndex] = useState(0);
  const itemTemplateImge = (item) => {
    return <img src={item.ID_apartments_file ? _endPoints.apartments.images + item.path_file : item.objectURL} alt={item.ID_apartments_file ? item.path_file : item.name} style={{ width: '100%', display: 'block' }} />;
  }
  const thumbnailTemplate = (item) => {
    return <img src={item.ID_apartments_file ? _endPoints.apartments.images + item.path_file : item.objectURL} alt={item.ID_apartments_file ? item.path_file : item.name} style={{ display: 'block' }} />;
  }
  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <center>
          <i
            className="pi pi-image m-4 p-5 "
            style={{
              fontSize: "5em",
              borderRadius: "50%",
              backgroundColor: "var(--surface-b)",
              color: "var(--surface-d)",
            }}
          ></i>
          <br></br>
          <p
            style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
            className="mt-4"
          >
            اسحب وأفلِت الصورة هنا.
          </p>
        </center>
      </div>
    );
  };
  const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined p-4 ml-2' };
  const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
  const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined p-4 mr-2' };
  const [dragIndex, setDragIndex] = useState(null);
  const handleDrop = (hoverIndex) => {
    const updated = [...files];
    const draggedItem = updated[dragIndex];
    // remove old position
    updated.splice(dragIndex, 1);
    // insert in new position
    updated.splice(hoverIndex, 0, draggedItem);
    set_files(updated);
  };
  const [LodingUpdate, setLodingUpdate] = useState(false);
  const UpdateApartment = async (e) => {
    setLodingUpdate(true)
    var formDate = new FormData();
    formDate.append('ID_apartment', data.ID_apartment);
    formDate.append('state', state ? 1 : 0);
    formDate.append('type', type?.en);
    formDate.append('stay_type', stay_type?.value ? stay_type?.value : stay_type);
    formDate.append('family_type', family_type?.value ? family_type?.value : family_type);
    formDate.append('number', number);
    formDate.append('name', name);
    formDate.append('number_people', number_people);
    formDate.append('number_people_max', number_people_max);
    formDate.append('rating_star', rating_star);
    formDate.append('price', price);
    formDate.append('discount', discount);
    formDate.append('number_bedrooms', number_bedrooms);
    formDate.append('number_living_room', number_living_room);
    formDate.append('number_kitchen', number_kitchen);
    formDate.append('number_bathrooms', number_bathrooms);
    formDate.append('accessories', JSON.stringify(selectedAccessories));
    formDate.append('details', details);
    formDate.append('latitude', ArryaMaxPepole.lat);
    formDate.append('longitude', ArryaMaxPepole.lng);
    formDate.append('sea_distance', sea_distance);
    files_delete.map(file => {
      formDate.append('images_delete[]', file);
    })
    files.map((file, sort) => {
      if (!file.ID_apartments_file) {
        formDate.append('images[]', file);
      }
      else {
        formDate.append('images_sort[]', file.ID_apartments_file);
      }
    })

    const response = await API.post(_endPoints.apartments.update, formDate)
    if (response?.success) {
      data?.toast.current.show({
        style: {
          fontFamily: "Cairo",
          fontSize: "1.2rem"
        },
        life: 5000,
        severity: 'success', summary: 'نجــاح', detail: response.msg
      });
      data?.set_show_update_apartment(false);
      data?.GetApartments();
    }
    else {
      toast.current.show({
        style: {
          fontFamily: "Cairo",
          fontSize: "1.2rem"
        },
        life: 5000,
        severity: 'error', summary: 'خطــاء', detail: response?.msg
      });
    }
    setLodingUpdate(false)
  }


  return (
    <div className="page-wrapper" dir="rtl" >
      <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
      {LodingGetAartment ?
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4"><Skeleton width="50%" height="3rem" className="mb-4"></Skeleton></div>
            <div className="col-md-4"><center> <Skeleton width="50%" height="3rem" className="mb-4"></Skeleton></center></div>
            <div className="col-md-4" dir="ltr"><Skeleton width="50%" height="3rem" className="mb-4"></Skeleton></div>
          </div>
          <Skeleton height=".5rem" className="mt-4 mb-4"></Skeleton>

          <div className="flex justify-content-between mt-3">
            <Skeleton width="100%" height="400px"></Skeleton>
          </div>
          <div className="row mt-4">
            <div className="col-md-6" dir="ltr"><Skeleton width="10%" height="3rem" className="mb-4"></Skeleton></div>
            <div className="col-md-6" ><Skeleton width="10%" height="3rem" className="mb-4"></Skeleton></div>
          </div>
        </div>
        :
        <Stepper ref={stepperRef} style={{ flexBasis: '50rem', maxWidth: '100%' }} headerPosition="bottom"  >
          <StepperPanel header={<><h5 className="pr-4 font-bold">بيــانات الاســاسيــة</h5></>} >
            <div className="p-1 p-md-4">
              <div className="card p-3 p-md-4" style={{ fontFamily: "Cairo", border: "1px solid rgba(0,0,0,0.08)", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)" }}>
                  <div className='col-md-12 mt-4'>
                    <div className="row pt-4 "  >
                      <div className='col-12 col-md-2 mb-4' style={{ fontFamily: "Cairo" }} >
                        <label id='ltype' className="col-md-12" >حــالة الإقـامة *</label>
                        <ToggleButton onIcon="pi pi-check pl-2" offIcon="pi pi-times pl-2" checked={state} onChange={(e) => set_state(e.value)} onLabel="فعـــال" offLabel="غيــر فعـــال" className="w-100" />
                      </div>
                      <div className='col-12 col-md-2  mb-4' style={{ fontFamily: "Cairo" }} >
                        <label id='ltype'>نـوع الإقـامة *</label>
                        <Dropdown value={type} onChange={(e) => handeltype(e)} options={ApartmentsTypesOption} optionLabel="ar"
                          placeholder="اختــار نــوع الإقــامة" className="col-md-12 w-100" emptyMessage={<center>لايــوجد عنـــاصر متــاحة</center>} />
                      </div>

                      <div className="col-12 col-md-2 mb-4">
                        <label id='lfamily_type' >طريقة الإقـامة * </label>

                        <SelectButton value={stay_type?.value ? stay_type?.value : stay_type} onChange={(e) => set_stay_type(e.value)} options={StayType} optionLabel="label" optionValue="value" className="w-100" />
                      </div>

                      <div className="col-12 col-md-3  mb-4">
                        <label id='lnumber' >كــود الإقـامة *<i className='pi pi-key mr-1'></i></label>
                        <InputText value={number}
                          maxLength={100} placeholder="A001" className="col-md-12 w-100"
                          field="visitor_name" dropdown onChange={(e) => handelnumber(e)} />
                        < label id="msg_number" style={{ paddingRight: "50px" }}></label>
                      </div>
                      <div className="col-12 col-md-3  mb-4">
                        <label id='lname' >اسم الإقـامة</label>
                        <InputText value={name}
                          maxLength={100} placeholder="الاسم" className="col-md-12 w-100"
                          onChange={(e) => handelname(e)} />
                        < label id="msg_name" style={{ paddingRight: "50px" }}></label>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row pt-4"  >
                      <div className="col-12 col-md-2 mb-4">
                        <label id='lnumber_people' >عدد الاشخاص *  <i className="pi pi-users"></i></label>
                        <InputNumber value={number_people} onValueChange={(e) => handelnumber_people(e)} min={0} max={20} showButtons buttonLayout="horizontal" className='col-md-12 p-0 w-100'
                          decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" inputStyle={{ textAlign: "center" }} />
                        < label id="msg_number_people" style={{ paddingRight: "50px" }}></label>
                      </div>

                      <div className="col-12 col-md-2 mb-4">
                        <label id='lnumber_people' >الحد الأدني للزيادة الأشخاص * </label>
                        <AutoComplete value={number_people_max} suggestions={items} completeMethod={search} onChange={(e) => handelnumber_Maxpeople(e)} dropdown itemTemplate={maxPepoleTemplateSelected} className="col-md-12 w-100" />
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label id='lfamily_type' >النزلاء المسموح بهم * </label>
                        <SelectButton value={family_type?.value ? family_type?.value : family_type} onChange={(e) => handelfamily_type(e)} options={FamilyType} optionLabel="label" optionValue="value" className="w-100" />
                      </div>

                      <div className="col-12 col-md-2 mb-4">
                        <label id='lrating_star' >تقــيم حســب رضـاء العمــلاء</label>
                        <Rating value={rating_star} onChange={(e) => handelrating_star(e)} cancel={false} className="d-flex align-items-center" style={{ height: "38px" }} />
                      </div>
                      <div className="col-12 col-md-2 mb-4">
                        <label id='lprice' >سعر ليلى *</label>
                        <InputNumber value={price} onValueChange={(e) => handelprice(e)} min={100} max={1000000} className="col-md-12 p-0 w-100" suffix=' د.ل' />
                      </div>
                      <div className="col-12 col-md-2 mb-4">
                        <label id='ldiscount' >التخفيض *</label>
                        <InputNumber value={discount} onValueChange={(e) => handeldiscount(e)} min={0} max={price} className="col-md-12 p-0 w-100" suffix=' د.ل' />
                      </div>
                      <div className="col-12 col-md-2 mb-4">
                        <label  >السعر بعد التخفيض</label>
                        <InputNumber value={price - discount} min={0} max={price} className="col-md-12 p-0 w-100" disabled suffix=' د.ل' inputStyle={{ fontWeight: "bold", color: "black" }} />
                      </div>

                    </div>
                  </div>
                  <center className="pt-4">
                    <Button label="التـالي" icon="pi pi-arrow-left mr-2" iconPos="right" onClick={() => stepperRef.current.nextCallback()} className="mr-2" />
                  </center>
                </div>
              </div>
          </StepperPanel>
          <StepperPanel header={<><h5 className="pr-4 font-bold">الغــرف والملحقــات</h5></>} >
            <div className="p-1 p-md-4">
              <div className="card p-3 p-md-4" style={{ fontFamily: "Cairo", border: "1px solid rgba(0,0,0,0.08)", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)" }}>
                  <div className='col-12 col-md-12 mt-4'>
                    <div className="row pt-4 mb-4"  >
                      <div className="col-12 col-md-2 mb-4">
                        <label id='lnumber_bedrooms' className="col-md-12 p-0" >عدد غرف النوم *  </label>
                        <InputNumber value={number_bedrooms} onValueChange={(e) => handelnumber_bedrooms(e)} min={0} max={20} showButtons buttonLayout="horizontal" className='col-md-12 p-0 w-100'
                          decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" inputStyle={{ textAlign: "center" }} />
                      </div>
                      <div className="col-12 col-md-2 mb-4">
                        <label id='lnumber_living_room' className="col-md-12 p-0" >عدد غرف المعيشة	 * </label>
                        <InputNumber value={number_living_room} onValueChange={(e) => handelnumber_living_room(e)} min={0} max={20} showButtons buttonLayout="horizontal" className='col-md-12 p-0 w-100'
                          decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" inputStyle={{ textAlign: "center" }} />
                      </div>
                      <div className="col-12 col-md-2 mb-4">
                        <label id='lnumber_kitchen' className="col-md-12 p-0">عدد غرف الطبخ	 *</label>
                        <InputNumber value={number_kitchen} onValueChange={(e) => handelnumber_kitchen(e)} min={0} max={20} showButtons buttonLayout="horizontal" className='col-md-12 p-0 w-100'
                          decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" inputStyle={{ textAlign: "center" }} />
                      </div>
                      <div className="col-12 col-md-2 mb-4">
                        <label id='lnumber_bathrooms' className="col-md-12 p-0" >عدد الحمامات		 * </label>
                        <InputNumber value={number_bathrooms} onValueChange={(e) => handelnumber_bathrooms(e)} min={0} max={20} showButtons buttonLayout="horizontal" className='col-md-12 p-0 w-100'
                          decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" inputStyle={{ textAlign: "center" }} />
                      </div>

                      <div className="col-12 col-md-4 mb-4" >
                        <label id='laccessories' className="col-md-12 p-0">الملحقات  * </label>
                        <MultiSelect value={selectedAccessories} onChange={(e) => setSelectedAccessories(e.value)} options={accessories} optionLabel="name_ar" selectedItemsLabel={`تم اختيار ${selectedAccessories ? selectedAccessories.length : 0} ملحقات`}
                          filter filterDelay={400} placeholder="اختار الملحقات" maxSelectedLabels={3} className="col-md-12 w-100" emptyMessage={<center>لايــوجد عنـــاصر</center>} itemTemplate={accessoriesTemplateSelected} />
                      </div>

                    </div>
                    <hr></hr>
                    <div className="row pt-4  mb-4"  >
                      <div className="col-md-12">
                        <label id='ldetails' >تفاصيــل الإقــامة</label>
                        <InputTextarea autoResize value={details} onChange={(e) => handeldetails(e)} rows={3} cols={30} className="col-md-12" />
                      </div>
                    </div>

                  </div>

                  <center className="pt-4">
                    <Button label="رجــوع" severity="secondary" icon="pi pi-arrow-right ml-2" iconPos="left" onClick={() => stepperRef.current.prevCallback()} className="ml-2" />

                    <Button label="التـالي" icon="pi pi-arrow-left mr-2" iconPos="right" onClick={() => stepperRef.current.nextCallback()} className="mr-2" />
                  </center>
                </div>
              </div>
          </StepperPanel>
          <StepperPanel header={<><h5 className="pr-4 font-bold">المــوقع والصــور</h5></>} >
            <div className="p-1 p-md-4">
              <div className="card p-3 p-md-4" style={{ fontFamily: "Cairo", border: "1px solid rgba(0,0,0,0.08)", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)" }}>
                  <div className='col-md-12 '>
                    <div className="row pt-4 mb-4"  >
                      <div className="col-md-6">
                        <label id='lnumber_people' >مــوقع الإقــامة</label>
                        <div className="space-y-4">
                          {
                            !isLoaded ?
                              <Skeleton width="100%" height="350px"></Skeleton>
                              :
                              <>
                                <GoogleMap
                                  mapContainerStyle={{ width: "100%", height: window.innerWidth <= 768 ? "280px" : "400px", borderRadius: "1rem" }}
                                  zoom={16}
                                  center={ArryaMaxPepole}
                                  onClick={onMapClick}
                                >
                                  <Marker position={ArryaMaxPepole} />
                                </GoogleMap>

                                <div className="text-sm text-gray-600">
                                  <strong>Latitude:</strong> {ArryaMaxPepole.lat.toFixed(6)} <br />
                                  <strong>Longitude:</strong> {ArryaMaxPepole.lng.toFixed(6)}
                                </div>
                              </>
                          }
                        </div>
                        <hr></hr>
                        <label id='lsea_distance' >مســافة شــاطئ</label>
                        <InputText value={sea_distance} onChange={(e) => handelsea_distance_target(e)} className="col-md-12" maxLength={4} />
                        <Slider value={sea_distance} onChange={(e) => handelsea_distance(e)} className="" min={0} max={1000} />
                      </div>

                      <div className="col-md-6">
                        <label id='lnumber_people' >صور الإقــامة</label>
                        <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
                        <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
                        <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />
                        <FileUpload ref={fileUploadRef} name="demo[]" url="/api/upload" multiple accept="image/*" maxFileSize={maxFileSize}
                          onUpload={onTemplateUpload} onSelect={(e) => {
                            onTemplateSelect(e);
                          }} onError={onTemplateClear} onClear={onTemplateClear}
                          headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={files.length === 0 ? emptyTemplate : null}
                          chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                        <div >
                          <div className="card flex justify-content-center">
                            <Galleria ref={galleria} value={files} numVisible={7} style={{ maxWidth: '850px' }}
                              activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                              circular fullScreen showItemNavigators showThumbnails={false} item={itemTemplateImge} thumbnail={thumbnailTemplate} />
                            <div className="grid">
                              <div
                                className="col-md-12"
                                style={{
                                  maxHeight: "500px",
                                  overflowY: "auto",
                                }}
                              >
                                {files?.map((image, index) => {
                                  let imgEl = (
                                    <img
                                      src={image.ID_apartments_file ? _endPoints.apartments.images + image.path_file : image.objectURL}
                                      alt={image.ID_apartments_file ? image.path_file : image.name}
                                      style={{ cursor: "grab", objectFit: "cover", width: "100%", height: "100px", borderRadius: "8px" }}
                                      onClick={() => {
                                        setActiveIndex(index);
                                        galleria.current.show();
                                      }}
                                    />
                                  );

                                  return (
                                    <React.Fragment key={image.name + index}>
                                      <div
                                        key={index}
                                        className="row"
                                        draggable
                                        onDragStart={() => setDragIndex(index)}
                                        onDragOver={(e) => can_sort ? e.preventDefault() : null}
                                        onDrop={() => handleDrop(index)}
                                        style={{
                                          border: "1px dashed #ccc",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <div className="col-5 col-md-6">{imgEl}</div>

                                        <div className="col-5 col-md-4 d-flex flex-column justify-content-center">
                                          <span className="text-truncate d-block" style={{ maxWidth: "100%", fontSize: "0.85rem", fontWeight: "bold" }}>
                                            {image.ID_apartments_file ? image.path_file.split('/').pop() : image.name}
                                          </span>
                                          {
                                            image?.size ?
                                              <div className="mt-1">
                                                <Tag
                                                  value={`${(image?.size / 1048576).toFixed(2)} MB`}
                                                  severity="warning"
                                                  className="px-2 py-1"
                                                  style={{ fontSize: "0.75rem" }}
                                                />
                                              </div>
                                              : null
                                          }
                                          <small className="text-muted mt-1">{new Date().toLocaleDateString()}</small>
                                        </div>

                                        <div className="col-2 col-md-2 d-flex align-items-center justify-content-center">
                                          <Button
                                            type="button"
                                            icon="pi pi-times"
                                            className="p-button-outlined p-button-rounded p-button-danger"
                                            onClick={(e) => {
                                              if (image?.ID_apartments_file) {
                                                set_files_delete([...files_delete, image.ID_apartments_file]);
                                                set_files(files.filter((a) => a !== image));
                                              }
                                              else {
                                                setTotalSize(totalSize - image.size);
                                                set_files(files.filter((a) => a !== image));
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <center className="pt-4">
                    <Button label="رجــوع" severity="secondary" icon="pi pi-arrow-right ml-2" iconPos="left" onClick={() => stepperRef.current.prevCallback()} className="ml-2" />

                    <Button label="تعــديل" severity="success" icon="pi pi-save mr-2" iconPos="right" onClick={UpdateApartment} className="mr-2 ml-2" loading={LodingUpdate} />
                  </center>
                </div>
              </div>
          </StepperPanel>
        </Stepper>
      }

    </div>
  )
}
export default ApartmentUpdateComponet